var sharedPrimitives = {
    primaryFontFamily: 'inherit',
};
export { sharedPrimitives };
